import { useEffect, useState } from "react";
import type { FormEvent } from "react";
import { Link } from "react-router-dom";

import { api } from "../api/client";

type Invitation = {
  id: number;
  email: string;
  token: string;
  accept_url: string;
  note: string;
  created_at: string;
  expires_at: string;
  sent_at: string | null;
  accepted_at: string | null;
  is_valid: boolean;
};

export default function InvitationsAdminPage() {
  const [items, setItems] = useState<Invitation[]>([]);
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function load() {
    const r = await api.get("/invitations/manage/");
    setItems(r.data.results || r.data);
  }
  useEffect(() => { load(); }, []);

  async function onCreate(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await api.post("/invitations/manage/", { email, note });
      setEmail(""); setNote("");
      await load();
    } catch (e: any) {
      setErr(e?.response?.data?.detail || JSON.stringify(e?.response?.data));
    } finally { setBusy(false); }
  }

  async function send(id: number) {
    await api.post(`/invitations/manage/${id}/send/`);
    await load();
  }

  async function revoke(id: number) {
    if (!confirm("Borrar invitación?")) return;
    await api.delete(`/invitations/manage/${id}/`);
    await load();
  }

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="brand">Videotool · Admin</div>
        <div className="spacer" />
        <Link to="/"><button>← Volver</button></Link>
      </div>
      <div className="dashboard">
        <h1>Invitaciones</h1>

        <form className="card" onSubmit={onCreate} style={{ marginBottom: 20 }}>
          <div style={{ display: "flex", gap: 12, alignItems: "flex-end" }}>
            <div style={{ flex: 2 }}>
              <label className="label">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div style={{ flex: 3 }}>
              <label className="label">Nota (opcional)</label>
              <input value={note} onChange={(e) => setNote(e.target.value)} />
            </div>
            <button className="primary" disabled={busy} type="submit">Crear invitación</button>
          </div>
          {err && <div className="error-text">{err}</div>}
        </form>

        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: "left", color: "var(--text-dim)" }}>
              <th style={{ padding: 8 }}>Email</th>
              <th style={{ padding: 8 }}>Estado</th>
              <th style={{ padding: 8 }}>Caducidad</th>
              <th style={{ padding: 8 }}>Enlace</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((i) => (
              <tr key={i.id} style={{ borderTop: "1px solid var(--border)" }}>
                <td style={{ padding: 8 }}>{i.email}</td>
                <td style={{ padding: 8 }}>
                  {i.accepted_at ? "✅ Aceptada" : i.is_valid ? (i.sent_at ? "📨 Enviada" : "Pendiente") : "⛔ Caducada"}
                </td>
                <td style={{ padding: 8 }}>{new Date(i.expires_at).toLocaleString()}</td>
                <td style={{ padding: 8 }}>
                  <button onClick={() => navigator.clipboard.writeText(i.accept_url)} style={{ fontSize: 11 }}>
                    Copiar enlace
                  </button>
                </td>
                <td style={{ padding: 8 }}>
                  {!i.accepted_at && (
                    <>
                      <button onClick={() => send(i.id)} style={{ fontSize: 11, marginRight: 4 }}>Enviar email</button>
                      <button className="danger" onClick={() => revoke(i.id)} style={{ fontSize: 11 }}>Borrar</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
